module.exports = __webpack_public_path__ + "static/media/checkered-diamond-03fce3.f6fe74fd.svg";